// Define observeAddToCartButtons first (before using it)
export const observeAddToCartButtons = function (timeOut) {

    var target = document.querySelectorAll(".add_to_cart_button:not(.observed), .single_add_to_cart_button:not(.observed)");

    if(target.length == 0 && timeOut == true) {
        //The node we need does not exist yet.
        //Wait 250ms and try again
        window.setTimeout(observeAddToCartButtons, 250);
        return;
    }

    for (var i = 0; i < target.length; i++) {

        target[i].classList.add('observed')

        target[i].addEventListener('click', function (event) {
            event.preventDefault();
            const parentNode = !event.target.classList.contains('add_to_cart_button') && !event.target.classList.contains('single_add_to_cart_button') ? event.target.parentNode : event.target
            const woobt_ids_elements = document.getElementsByName('woobt_ids')
            let additional_products = []

            // woobt support
            if (woobt_ids_elements.length == 1) {
                const woobt_ids_el = woobt_ids_elements[0]
                let additional_products_value = woobt_ids_el.value

                if (woobt_ids_el.value) {
                    let additional_products_values = woobt_ids_el.value.split(',')

                    additional_products_values.forEach((product) => {
                        var additional_product_data = product.split('/')
                        var this_additional_product = {
                            product_id: additional_product_data[0] || null,
                            quantity: additional_product_data[2] || null
                        }
                        additional_products.push(this_additional_product)
                    })

                }

            }

            // Get product name for toast (try multiple sources)
            let productName = parentNode.dataset.product_name ||
                              parentNode.closest('[data-product-name]')?.dataset.productName ||
                              parentNode.closest('.product')?.querySelector('.product-title, .woocommerce-loop-product__title, h2, h3')?.textContent?.trim() ||
                              'Produkt';

            let quantity = parseInt(parentNode.dataset.quantity) || 1;

            const data = {
                'action': 'add_to_cart_custom',
                'product_id': parentNode.dataset.product_id,
                'variation_id': parentNode.dataset.variation_id,
                'additional_products': additional_products,
                'quantity': parentNode.dataset.quantity ? parentNode.dataset.quantity : 0
            }

            // Torg Pricing pack (buy-box "Förpackning" chip, torg-pricing.js):
            // quantity is in units (packs × N), torg_pack = N makes it a pack line.
            const torgPack = parseInt(parentNode.dataset.torg_pack, 10) || 0;
            let packLabel = '';
            if (torgPack > 1) {
                data.torg_pack = torgPack;
                packLabel = `${torgPack}-pack`;
                quantity = Math.max(1, Math.round(quantity / torgPack));
            }

            jQuery.ajax({
                url: wc_add_to_cart_params.ajax_url,
                method: 'post',
                data: data,
                beforeSend: function (response) {
                    parentNode.classList.add('loading')
                },
                complete: function (response) {
                    parentNode.classList.remove('loading')
                },
                success: function (response) {
                    if (response.cart_hash ) {
                        // Match WC core's [fragments, cart_hash, $button] signature —
                        // listeners like torg-track.js read the product off the button.
                        jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, jQuery(parentNode)]);
                        jQuery(document.body).trigger('wc_fragment_refresh');

                        // Force refresh fragments, else it won't work on start page etc
                        if(response.fragments) {
                            for (const [key, value] of Object.entries(response.fragments)) {
                                let el = document.querySelector(key)
                                if (el) {
                                    el.outerHTML = value
                                }
                            }

                        }
                        const ctaLabel = parentNode.querySelector('[data-versa-cta-label]')
                        if (ctaLabel) {
                            // Buy-box CTA: green "Tillagd" with a check, then its own label again.
                            window.clearTimeout(parentNode.versaAddedTimer)
                            if (!parentNode.classList.contains('versa-cta--added')) {
                                parentNode.dataset.versaLabel = ctaLabel.textContent
                            }
                            ctaLabel.textContent = 'Tillagd'
                            parentNode.classList.add('versa-cta--added')
                            parentNode.versaAddedTimer = window.setTimeout(function () {
                                parentNode.classList.remove('versa-cta--added')
                                ctaLabel.textContent = parentNode.dataset.versaLabel || ctaLabel.textContent
                                delete parentNode.dataset.versaLabel
                            }, 2000)
                        } else {
                            parentNode.classList.add('added')
                            parentNode.classList.add('animate-bounce-once')
                            window.setTimeout(function (parentNode) {
                                parentNode.classList.remove('added')
                                parentNode.classList.remove('animate-bounce-once')
                            }, 2000, parentNode);
                        }

                        // Show toast and animate cart icon instead of opening mini-cart
                        showAddedToCartToast(productName, quantity, packLabel);
                        animateCartIcon();

                        jQuery( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
                    } else {

                        jQuery( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
                        jQuery('.woocommerce-notices-wrapper').append(response);

                        return;
                    }
                }
            })
        })
    }
}

// Make globally available for external calls
window.observeAddToCartButtons = observeAddToCartButtons;

jQuery(document).ready(function($){
    observeAddToCartButtons(true);

    // Re-observe buttons when mini-cart opens (content loaded dynamically)
    window.addEventListener('openminicart', function() {
        setTimeout(function() { observeAddToCartButtons(false); }, 100);
    });

    // Re-observe when fragments are refreshed (WooCommerce AJAX)
    $(document.body).on('wc_fragments_refreshed wc_fragments_loaded', function() {
        setTimeout(function() { observeAddToCartButtons(false); }, 100);
    });

    // Also re-observe periodically to catch any missed buttons (e.g., from lazy-loaded content)
    setInterval(function() {
        var unobserved = document.querySelectorAll('.add_to_cart_button:not(.observed)');
        if (unobserved.length > 0) {
            observeAddToCartButtons(false);
        }
    }, 1000);
});

/**
 * Show "Added to cart" toast notification
 */
function showAddedToCartToast(productName, quantity, packLabel) {
    const toastId = `cart-toast-${Date.now()}`;
    const displayName = productName.length > 40 ? productName.substring(0, 40) + '...' : productName;
    // Packs first so the line stays readable when the name is cut: "2x 10-pack Name".
    const qtyText = (quantity > 1 ? `${quantity}x ` : '') + (packLabel ? `${packLabel} ` : '');

    // Remove any existing cart toasts
    document.querySelectorAll('.cart-added-toast').forEach(t => t.remove());

    const toast = document.createElement('div');
    toast.id = toastId;
    toast.className = 'cart-added-toast fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm bg-gray-900 text-white rounded-xl shadow-2xl p-4 z-50 transform translate-y-full opacity-0 transition-all duration-300';
    toast.innerHTML = `
        <div class="flex items-center gap-3">
            <div class="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <div class="flex-1 min-w-0">
                <p class="text-sm font-medium">Tillagd i varukorgen</p>
                <p class="text-xs text-gray-300 truncate">${qtyText}${displayName}</p>
            </div>
            <a href="/cart" class="flex-shrink-0 px-3 py-1.5 bg-white text-gray-900 text-sm font-medium rounded-lg hover:bg-gray-100 transition-colors">
                Visa
            </a>
        </div>
    `;

    document.body.appendChild(toast);

    // The toast is visual only; announce the same status to screen readers.
    if (window.versaAnnounce) {
        window.versaAnnounce(`Tillagd i varukorgen: ${qtyText}${productName}`);
    }

    // Animate in
    requestAnimationFrame(() => {
        toast.classList.remove('translate-y-full', 'opacity-0');
    });

    // Auto-dismiss after 4 seconds
    setTimeout(() => {
        toast.classList.add('translate-y-full', 'opacity-0');
        setTimeout(() => toast.remove(), 300);
    }, 4000);
}

/**
 * Animate the cart icon in header
 */
function animateCartIcon() {
    const cartButton = document.getElementById('mini-cart-count');
    if (cartButton) {
        // Add pulse/bounce animation
        cartButton.classList.add('cart-icon-bounce');
        setTimeout(() => {
            cartButton.classList.remove('cart-icon-bounce');
        }, 600);
    }
}